import { ENV_LISTS } from "../../EnvTranspiler";

export const API_TIMEOUT = 30000;
export const BASE_URL = ENV_LISTS.API_URL
export const LOCAL_STORAGE_KEY = ENV_LISTS.KEY_TOKEN